// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"fb2705ee","293":"c0c3a98a","474":"fa8f9943","837":"dfd0dc1b"}[chunkId] + ".chunk.js";
};